export type CardId = 'lock-position' | 'card-lock' | 'throw-card' | 'draw-one';

export type Card = {
    id: CardId;
    instanceId: string;
};

// Card metadata. `artKey` maps to the card art in the DOM (card-01.svg).
export const CARD_TYPES: Record<CardId, { name: string; artKey: string; description: string }> = {
    'lock-position': {
        name: 'LOCK POSITION',
        artKey: 'card-01',
        description:
            'Lock any empty position for one turn cycle. While locked, no piece can move onto that cell - for either player. The lock lasts until the turn returns to you, and playing this card skips your move.',
    },
    'card-lock': {
        name: 'CARD LOCK',
        artKey: 'card-02',
        description:
            "Lock the opponent's cards for one turn cycle. While locked, the opponent cannot activate any card - but they still draw and move normally. The lock lasts until the opponent's turn ends. Playing this card does not skip your move - you may still move a piece this turn.",
    },
    'throw-card': {
        name: 'THROW CARD',
        artKey: 'card-03',
        description:
            'Force the opponent to discard 1 random card from their hand.  Playing this card does not skip your move - you may still move a piece this turn.',
    },
    'draw-one': {
        name: 'DRAW CARD',
        artKey: 'card-04',
        description:
            'Draw 1 card from the deck. You may then activate the card you drew - and only that card - if you wish. Playing this card does not skip your move - you may still move a piece this turn.',
    },
};

const CARD_POOL: CardId[] = ['lock-position', 'card-lock', 'throw-card', 'draw-one'];

let instanceCounter = 0;

const nextInstanceId = (): string => `card-${++instanceCounter}`;

export const shuffle = <T,>(array: readonly T[]): T[] => {
    const copy = [...array];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = copy[i];
        copy[i] = copy[j];
        copy[j] = tmp;
    }
    return copy;
};

export const createDeck = (count = 30): Card[] => {
    const cards: Card[] = [];
    for (let i = 0; i < count; i++) {
        cards.push({ id: CARD_POOL[i % CARD_POOL.length], instanceId: nextInstanceId() });
    }
    return shuffle(cards);
};

export const drawCard = (deck: Card[]): { card: Card; remaining: Card[] } | null => {
    if (deck.length === 0) {
        return null;
    }
    const [card, ...remaining] = deck;
    return { card, remaining };
};
